function getCharacterUrls(character, poses) {
    const urls = {};
    poses.forEach(pose => {
        urls[pose] = `/NoTimeToStalk/assets/characters/${character}/${pose}.png`;
    });
    return urls;
}
export const characters = {
    red: getCharacterUrls("red", [
        "smile",
        "neutral",
        "suspicious",
        "nervous",
        "angry"
    ]),
    yellow: getCharacterUrls("yellow", [
        "smile",
        "neutral",
        "suspicious",
        "nervous",
        "angry"
    ]),
    pink: getCharacterUrls("pink", [
        "smile",
        "neutral",
        "suspicious",
        "nervous",
        "angry"
    ]),
    green: getCharacterUrls("green", [
        "smile",
        "neutral",
        "suspicious",
        "nervous",
        "angry"
    ]),
    blue: getCharacterUrls("blue", [
        "smile",
        "neutral",
        "suspicious",
        "nervous",
        "angry"
    ]),
    black: getCharacterUrls("black", [
        "smile",
        "neutral",
        "suspicious",
        "nervous",
        "angry"
    ]),
    futureLady: getCharacterUrls("futureLady", [
        "desperate",
        "smile",
        "neutral",
        "sly",
        "serious",
        "shocked",
        "confused"
    ]),
    host: getCharacterUrls("host", [
        "happy",
        "confused",
        "neutral",
        "suspicious"
    ]),
    dog: getCharacterUrls("dog", ["happy", "neutral", "suspicious"]),
    futureRando: getCharacterUrls("futureRando", ["angry", "confused", "desperate"]),
    investigator: getCharacterUrls("investigator", ["serious", "speaking", "listening", "neutral"]),
};
const _assertCharacters = characters;
